import {
  GET_AREAS,
  GET_AREAS_FAIL,
  GET_AREAS_SUCCESS,
  ADD_AREA,
  ADD_AREA_SUCCESS,
  ADD_AREA_FAIL,
  UPDATE_AREA,
  UPDATE_AREA_SUCCESS,
  UPDATE_AREA_FAIL,
  DELETE_CUSTOM_PLANT,
  DELETE_CUSTOM_PLANT_SUCCESS,
  DELETE_CUSTOM_PLANT_FAIL,
  GET_CUSTOM_PLANTS,
  GET_CUSTOM_PLANTS_SUCCESS,
  GET_CUSTOM_PLANTS_FAIL,
  UPDATE_CUSTOM_PLANT,
  UPDATE_CUSTOM_PLANT_SUCCESS,
  UPDATE_CUSTOM_PLANT_FAIL,
  SAVE_CUSTOM_PLANT,
  SAVE_CUSTOM_PLANT_SUCCESS,
  SAVE_CUSTOM_PLANT_FAIL,
  DELETE_AREA,
  DELETE_AREA_SUCCESS,
  DELETE_AREA_FAIL,
  GET_OBJECTIVES,
  GET_OBJECTIVES_SUCCESS,
  GET_OBJECTIVES_FAIL,
  SAVE_OBJECTIVES,
  SAVE_OBJECTIVES_SUCCESS,
  SAVE_OBJECTIVES_FAIL,
  SEARCH_GUILD,
  SEARCH_GUILD_SUCCESS,
  SEARCH_GUILD_FAILURE,
  GET_USER_GUILDS, GET_USER_GUILDS_SUCCESS, GET_USER_GUILDS_FAIL,
  CREATE_USER_GUILD, CREATE_USER_GUILD_SUCCESS, CREATE_USER_GUILD_FAIL,
  UPDATE_USER_GUILD, UPDATE_USER_GUILD_SUCCESS, UPDATE_USER_GUILD_FAIL,
  DELETE_USER_GUILD, DELETE_USER_GUILD_SUCCESS, DELETE_USER_GUILD_FAIL,
} from "./actionTypes"


export const searchGuild = searchGuildParams => ({
  type: SEARCH_GUILD,
  payload: searchGuildParams,
})

export const searchGuildSuccess = plants => ({
  type: SEARCH_GUILD_SUCCESS,
  payload: plants,
})

export const searchGuildFail = error => ({
  type: SEARCH_GUILD_FAILURE,
  payload: error,
})

export const getAreas = () => ({
  type: GET_AREAS,
})

export const getAreasSuccess = areas => ({
  type: GET_AREAS_SUCCESS,
  payload: areas,
})

export const getAreasFail = error => ({
  type: GET_AREAS_FAIL,
  payload: error,
})

export const addArea = (area) => ({
  type: ADD_AREA,
  payload: area
})

export const addAreaSuccess = (area) => ({
  type: ADD_AREA_SUCCESS,
  payload: area
})

export const addAreaFail = error => ({
  type: ADD_AREA_FAIL,
  payload: error,
})

export const fetchCustomPlants = () => ({
  type: GET_CUSTOM_PLANTS,
})

export const fetchCustomPlantsSuccess = (customPlants) => ({
  type: GET_CUSTOM_PLANTS_SUCCESS,
  payload: customPlants
})

export const fetchCustomPlantsFail = error => ({
  type: GET_CUSTOM_PLANTS_FAIL,
  payload: error,
})

export const updateArea = (area) => ({
  type: UPDATE_AREA,
  payload: area
})

export const updateAreaSuccess = (area) => ({
  type: UPDATE_AREA_SUCCESS,
  payload: area
})

export const updateAreaFail = error => ({
  type: UPDATE_AREA_FAIL,
  payload: error,
})

export const updateCustomPlant = (plant) => ({
  type: UPDATE_CUSTOM_PLANT,
  payload: plant
})

export const updateCustomPlantSuccess = (plant) => ({
  type: UPDATE_CUSTOM_PLANT_SUCCESS,
  payload: plant
})

export const updateCustomPlantFail = error => ({
  type: UPDATE_CUSTOM_PLANT_FAIL,
  payload: error,
})

export const saveCustomPlant = (plant) => ({
  type: SAVE_CUSTOM_PLANT,
  payload: plant
})

export const saveCustomPlantSuccess = (plant) => ({
  type: SAVE_CUSTOM_PLANT_SUCCESS,
  payload: plant
})

export const saveCustomPlantFail = error => ({
  type: SAVE_CUSTOM_PLANT_FAIL,
  payload: error,
})

export const deleteArea = (id) => ({
  type: DELETE_AREA,
  payload: id
})

export const deleteAreaSuccess = (id) => ({
  type: DELETE_AREA_SUCCESS,
  payload: id
})

export const deleteAreaFail = error => ({
  type: DELETE_AREA_FAIL,
  payload: error,
})

export const deleteCustomPlant = (id) => ({
  type: DELETE_CUSTOM_PLANT,
  payload: id
})

export const deleteCustomPlantSuccess = (id) => ({
  type: DELETE_CUSTOM_PLANT_SUCCESS,
  payload: id
})

export const deleteCustomPlantFail = error => ({
  type: DELETE_CUSTOM_PLANT_FAIL,
  payload: error,
})

export const getObjectives = () => ({
  type: GET_OBJECTIVES,
})

export const getObjectivesSuccess = (objectives) => ({
  type: GET_OBJECTIVES_SUCCESS,
  payload: objectives
})

export const getObjectivesFail = error => ({
  type: GET_OBJECTIVES_FAIL,
  payload: error,
})

export const saveObjectives = (objectives) => ({
  type: SAVE_OBJECTIVES,
  payload: objectives,
})

export const saveObjectivesSuccess = (objectives) => ({
  type: SAVE_OBJECTIVES_SUCCESS,
  payload: objectives
})

export const saveObjectivesFail = error => ({
  type: SAVE_OBJECTIVES_FAIL,
  payload: error,
})

// ── User Guilds ────────────────────────────────────────────────────────────
export const getUserGuilds = () => ({ type: GET_USER_GUILDS })
export const getUserGuildsSuccess = guilds => ({ type: GET_USER_GUILDS_SUCCESS, payload: guilds })
export const getUserGuildsFail = error => ({ type: GET_USER_GUILDS_FAIL, payload: error })

export const createUserGuild = guild => ({ type: CREATE_USER_GUILD, payload: guild })
export const createUserGuildSuccess = guild => ({ type: CREATE_USER_GUILD_SUCCESS, payload: guild })
export const createUserGuildFail = error => ({ type: CREATE_USER_GUILD_FAIL, payload: error })

export const updateUserGuild = guild => ({ type: UPDATE_USER_GUILD, payload: guild })
export const updateUserGuildSuccess = guild => ({ type: UPDATE_USER_GUILD_SUCCESS, payload: guild })
export const updateUserGuildFail = error => ({ type: UPDATE_USER_GUILD_FAIL, payload: error })

export const deleteUserGuild = id => ({ type: DELETE_USER_GUILD, payload: id })
export const deleteUserGuildSuccess = id => ({ type: DELETE_USER_GUILD_SUCCESS, payload: id })
export const deleteUserGuildFail = error => ({ type: DELETE_USER_GUILD_FAIL, payload: error })


